import { DocumentMatchCellContentProps } from "@components/accounting/transactionMatch/DocumentMatchCellContent";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { BillsViewCallbacks } from "./billsView/types";
import { BillMatchTableOptions } from "./useBillMatchTableOptions";

/**
 * Read the table meta in the cell body: the cell re-renders with each new
 * `tableMeta`, but a child that only receives `table` would be skipped.
 */
export function useBillMatchCellProps({
    billId,
    table,
}: {
    billId: string;
    table: { options: { meta?: object } };
}): DocumentMatchCellContentProps {
    const { options } = useViewTableMeta<
        BillsViewCallbacks,
        BillMatchTableOptions
    >(table);

    return {
        documentType: "bill",
        documentId: billId,
        status: options?.accrualMatchSummariesStatus,
        summary: options?.accrualMatchSummaries.get(billId),
        readonly: options?.readonly,
    };
}
